import type { Invite } from '@/types'

export const invites: Invite[] = [
  {
    id: 'inv1',
    serverId: 's1',
    code: 'arcus-hq-2026',
    createdBy: 'u1',
    createdAt: Date.now() - 86400000 * 3,
    expiresAt: Date.now() + 86400000 * 4,
    maxUses: null,
    uses: 47,
  },
  {
    id: 'inv2',
    serverId: 's1',
    code: 'dev-invite-42',
    createdBy: 'u2',
    createdAt: Date.now() - 86400000,
    expiresAt: Date.now() + 86400000 * 6,
    maxUses: 100,
    uses: 12,
  },
  {
    id: 'inv3',
    serverId: 's2',
    code: 'rust-devs-join',
    createdBy: 'u2',
    createdAt: Date.now() - 86400000 * 7,
    expiresAt: null,
    maxUses: null,
    uses: 234,
  },
]
